export default {
  changeLanguageTips: '切换语言成功',
  unknownError: '未知错误，请联系管理员！',
}
